// This file is intended for global constants that are shared across
// the application. Use this file sparingly. For constants with a single
// usage, it can be better to include them in the module scope of the
// file they're used in.

// Minimum number of vehicles for comparison
export const MINIMUM_VEHICLES = 2;

// UUID format used for vehicle IDs (32 hex chars)
export const UUID_REGEX = /^[a-fA-F0-9]{32}$/;

export const ACTIONS = {
	SCROLL_END: 'ws-vehicle-compare/scroll-end',
	SCROLL_START: 'ws-vehicle-compare/scroll-start'
};

export const DIRECTION = {
	RIGHT: 'right',
	LEFT: 'left',
	OFFSET: {
		right: 1,
		left: -1
	}
};
